import XLSX from 'xlsx';
import XLSX_STYLE from 'xlsx-js-style';
import _ from 'lodash';

export class MyXLSX2 {
    static createBook() {
        return XLSX.utils.book_new();
    }

    static bookAppendSheet(book, sheet, sheetName) {
        XLSX.utils.book_append_sheet(book, sheet, sheetName);
    }

    static createSheet(title, headRows, bodyHeader, bodyRows, noMerge) {
        // create sheet
        const rows = this.dataConvertToRows(title, headRows, bodyHeader, bodyRows, noMerge);
        const sheet = XLSX.utils.aoa_to_sheet(rows);

        // 標題列是否存在 (title 為空則不產生標題列)
        const TITLE_ROW_COUNT = title ? 1 : 0;

        // merge cells
        const LAST_COL = bodyHeader.length - 1 > 3 ? bodyHeader.length - 1 : 3;
        sheet['!merges'] = [];
        if (title) {
            sheet['!merges'].push({ s: { r: 0, c: 1 }, e: { r: 0, c: LAST_COL } }); // 標題
        }
        _.forEach(headRows, (value, index) => {
            const r = index + TITLE_ROW_COUNT;
            sheet['!merges'].push({ s: { r, c: 1 }, e: { r, c: noMerge ? 1 : 2 } }); // 自訂匯總資訊-label
            sheet['!merges'].push({ s: { r, c: noMerge ? 2 : 3 }, e: { r, c: LAST_COL } }); // 自訂匯總資訊-value
        });

        // set cell styles
        // 設定全部行高 (標題列高度 50, 其餘 25)
        sheet['!rows'] = _.map(rows, (o, i) => ({ hpx: i === 0 && title ? 50 : 25 }));

        // 設定全部欄寬 (由bodyHeader定義，預設 15)
        sheet['!cols'] = _.map(bodyHeader, (h) => ({ wch: h.width ? h.width : 15 }));

        // 逐格樣式設定
        const HEADER_ROW_INDEX = headRows.length + TITLE_ROW_COUNT + 1;
        _.forEach(sheet, (value, key) => {
            if (!key.includes('!')) {
                // 'B13' => COL: 'B', ROW: '13'
                const isLetterSingle = !Number.isNaN(Number(key.substring(1)));
                const COL = isLetterSingle ? key.substring(0, 1) : key.substring(0, 2);
                const ROW = isLetterSingle ? Number(key.substring(1)) : Number(key.substring(2));
                const colSetting = bodyHeader[this.AlphabetToNumber(COL, isLetterSingle)];

                // 每一格
                sheet[key].s = {
                    font: {
                        name: 'Microsoft JhengHei',
                    },
                    alignment: {
                        horizontal: 'left',
                        vertical: 'center',
                    },
                    border: {
                        bottom: { style: 'thin', color: 'FFFFFFFF' },
                        top: { style: 'thin', color: 'FFFFFFFF' },
                        right: { style: 'thin', color: 'FFFFFFFF' },
                        left: { style: 'thin', color: 'FFFFFFFF' },
                    },
                };

                if (COL === 'A' && ROW < headRows.length + TITLE_ROW_COUNT + 1) {
                    // 標題＆自訂匯總 第一格空白
                    sheet[key].s.border.right = null;
                }
                if (COL === 'B' && ROW < headRows.length + TITLE_ROW_COUNT + 1) {
                    // 標題＆自訂匯總 第二格，取消左邊隔線
                    sheet[key].s.border.left = null;
                }
                if (COL === 'D' && ROW < headRows.length + TITLE_ROW_COUNT + 1) {
                    // 自訂匯總-value
                    if (typeof sheet[key].v === 'number') {
                        sheet[key].z = '#,##0_-;-#,##0_-;0;General';
                    }
                }
                if (title && key === 'B1') {
                    // 標題
                    sheet[key].s.font = { name: 'Microsoft JhengHei', sz: 18, bold: true };
                }
                if (ROW === HEADER_ROW_INDEX) {
                    // 資料表頭
                    sheet[key].s = {
                        font: {
                            name: 'Microsoft JhengHei',
                            sz: 12,
                            bold: true,
                        },
                        alignment: {
                            horizontal: 'center',
                            vertical: 'center',
                        },
                        border: {
                            bottom: { style: 'medium', color: 'FFFFFFFF' },
                            top: { style: 'medium', color: 'FFFFFFFF' },
                            right: { style: 'thin', color: 'FFFFFFFF' },
                            left: { style: 'thin', color: 'FFFFFFFF' },
                        },
                    };
                }
                if (ROW > HEADER_ROW_INDEX) {
                    // 資料
                    if (colSetting.align) {
                        sheet[key].s.alignment.horizontal = colSetting.align;
                    }
                    if (colSetting.number) {
                        sheet[key].z = '#,##0_-;-#,##0_-;0;General';
                    }
                }
            }
        });
        return sheet;
    }

    static dataConvertToRows(title, headRows, bodyHeader, bodyRows, noMerge) {
        let rows = [];
        // 標題 (title 為空則不產生標題列)
        if (title) {
            rows.push(['', title, ...this.createEmptyCols(bodyHeader.length - 2)]);
        }

        // 自訂匯總資訊
        for (let i = 0; i < headRows.length; i += 1) {
            if (noMerge) {
                rows.push(['', headRows[i].label, headRows[i].value, ...this.createEmptyCols(bodyHeader.length - 3)]);
            } else {
                rows.push(['', headRows[i].label, '', headRows[i].value, ...this.createEmptyCols(bodyHeader.length - 4)]);
            }
        }

        // 資料表頭
        const bodyHeaderCols = [];
        for (let i = 0; i < bodyHeader.length; i += 1) {
            bodyHeaderCols.push(bodyHeader[i].text);
        }
        rows.push(bodyHeaderCols);

        // 全部資料
        rows = rows.concat(bodyRows);
        return rows;
    }

    static createInvoiceSheet(title, headRows, bodyHeader, bodyRows, statusTxt) {
        // create sheet
        const rows = this.invoiceDataConvertToRows(title, headRows, bodyHeader, bodyRows, statusTxt);
        const sheet = XLSX.utils.aoa_to_sheet(rows);

        // merge cells
        const LAST_COL = bodyHeader.length - 1 > 3 ? bodyHeader.length - 1 : 3;
        sheet['!merges'] = [
            { s: { r: 0, c: 1 }, e: { r: 0, c: LAST_COL } }, // 標題
        ];
        _.forEach(headRows, (value, index) => {
            const r = index + 1;
            sheet['!merges'].push({ s: { r, c: 1 }, e: { r, c: 2 } }); // 自訂匯總資訊-label
            sheet['!merges'].push({ s: { r, c: 3 }, e: { r, c: LAST_COL } }); // 自訂匯總資訊-value
        });

        // set cell styles
        // 設定全部行高 (首行高度 40, 其餘 25)
        sheet['!rows'] = _.map(rows, (o, i) => ({ hpx: i === 0 ? 50 : 25 }));

        // 設定全部欄寬 (由bodyHeader定義，預設 15)
        sheet['!cols'] = _.map(bodyHeader, (h) => ({ wch: h.width ? h.width : 15 }));

        const HEADER_ROW_INDEX = headRows.length + 2;

        // 發票歸類項目合併
        switch (statusTxt) {
        case '開立前':
            sheet['!merges'].push({
                s: { r: HEADER_ROW_INDEX - 1, c: 1 },
                e: { r: HEADER_ROW_INDEX - 1, c: 5 },
            });
            sheet['!merges'].push({
                s: { r: HEADER_ROW_INDEX - 1, c: 6 },
                e: { r: HEADER_ROW_INDEX - 1, c: 12 },
            });
            break;
        case '開立後':
            sheet['!merges'].push({
                s: { r: HEADER_ROW_INDEX - 1, c: 1 },
                e: { r: HEADER_ROW_INDEX - 1, c: 6 },
            });
            sheet['!merges'].push({
                s: { r: HEADER_ROW_INDEX - 1, c: 7 },
                e: { r: HEADER_ROW_INDEX - 1, c: 18 },
            });
            sheet['!merges'].push({
                s: { r: HEADER_ROW_INDEX - 1, c: 19 },
                e: { r: HEADER_ROW_INDEX - 1, c: 25 },
            });
            break;
        case '退件':
            sheet['!merges'].push({
                s: { r: HEADER_ROW_INDEX - 1, c: 1 },
                e: { r: HEADER_ROW_INDEX - 1, c: 8 },
            });
            sheet['!merges'].push({
                s: { r: HEADER_ROW_INDEX - 1, c: 9 },
                e: { r: HEADER_ROW_INDEX - 1, c: 15 },
            });
            break;
        default:
        }

        // 逐格樣式設定
        _.forEach(sheet, (value, key) => {
            if (!key.includes('!')) {
                // 'B13' => COL: 'B', ROW: '13'
                const isLetterSingle = !Number.isNaN(Number(key.substring(1)));
                const COL = isLetterSingle ? key.substring(0, 1) : key.substring(0, 2);
                const ROW = isLetterSingle ? Number(key.substring(1)) : Number(key.substring(2));
                const colSetting = bodyHeader[this.AlphabetToNumber(COL, isLetterSingle)];

                // 每一格
                sheet[key].s = {
                    alignment: {
                        horizontal: 'left',
                        vertical: 'center',
                    },
                    border: {
                        bottom: { style: 'thin', color: 'FFFFFFFF' },
                        top: { style: 'thin', color: 'FFFFFFFF' },
                        right: { style: 'thin', color: 'FFFFFFFF' },
                        left: { style: 'thin', color: 'FFFFFFFF' },
                    },
                };

                if (COL === 'A' && ROW < headRows.length + 2) {
                    // 標題＆自訂匯總 第一格空白
                    sheet[key].s.border.right = null;
                }
                if (COL === 'B' && ROW < headRows.length + 2) {
                    // 標題＆自訂匯總 第二格，取消左邊隔線
                    sheet[key].s.border.left = null;
                }
                if (COL === 'D' && ROW < headRows.length + 2) {
                    // 自訂匯總-value
                    if (typeof sheet[key].v === 'number') {
                        sheet[key].z = '#,##0_-;-#,##0_-;0;General';
                    }
                }
                if (key === 'B1') {
                    // 標題
                    sheet[key].s.font = { name: 'Microsoft JhengHei', sz: 18, bold: true };
                }
                if (ROW === HEADER_ROW_INDEX) {
                    // 資料表頭
                    const V = value.v.split(',');
                    sheet[key].v = _.first(V);
                    sheet[key].s = {
                        font: {
                            name: 'Microsoft JhengHei',
                            sz: 12,
                            bold: true,
                        },
                        alignment: {
                            horizontal: 'left',
                            vertical: 'center',
                        },
                        border: {
                            bottom: { style: 'medium', color: 'FFFFFFFF' },
                            top: { style: 'medium', color: 'FFFFFFFF' },
                            right: { style: 'thin', color: 'FFFFFFFF' },
                            left: { style: 'thin', color: 'FFFFFFFF' },
                        },
                        fill: { fgColor: { rgb: _.last(V) } },
                    };
                }
                if (ROW === HEADER_ROW_INDEX + 1) {
                    // 資料表頭
                    sheet[key].s = {
                        font: {
                            name: 'Microsoft JhengHei',
                            sz: 12,
                            bold: true,
                        },
                        alignment: {
                            horizontal: 'center',
                            vertical: 'center',
                        },
                        border: {
                            bottom: { style: 'medium', color: 'FFFFFFFF' },
                            top: { style: 'medium', color: 'FFFFFFFF' },
                            right: { style: 'thin', color: 'FFFFFFFF' },
                            left: { style: 'thin', color: 'FFFFFFFF' },
                        },
                    };
                }
                if (ROW > HEADER_ROW_INDEX + 1) {
                    // 資料
                    if (colSetting.align) {
                        sheet[key].s.alignment.horizontal = colSetting.align;
                    }
                    if (colSetting.number) {
                        sheet[key].z = '#,##0_-;-#,##0_-;0;General';
                    }
                }
            }
        });
        return sheet;
    }

    static invoiceDataConvertToRows(title, headRows, bodyHeader, bodyRows, statusTxt) {
        let rows = [];
        // 標題
        rows.push(['', title, ...this.createEmptyCols(bodyHeader.length - 2)]);

        // 自訂匯總資訊
        for (let i = 0; i < headRows.length; i += 1) {
            rows.push(['', headRows[i].label, '', headRows[i].value, ...this.createEmptyCols(bodyHeader.length - 4)]);
        }

        // 資料表頭
        const bodyHeaderCols = [];

        for (let i = 0; i < bodyHeader.length; i += 1) {
            bodyHeaderCols.push(bodyHeader[i].text);
        }

        let colorHeader;
        switch (statusTxt) {
        case '開立前':
            colorHeader = [',FFFFFF', '資訊,d9d9d9', ',d9d9d9', ',d9d9d9', ',d9d9d9', ',d9d9d9', '立帳,ffd966', ',ffd966', ',ffd966', ',ffd966', ',ffd966', ',ffd966', ',ffd966', '金流,b6d7a8'];
            break;
        case '開立後':
            colorHeader = [
                ',FFFFFF',
                '資訊,d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                '立帳,ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                '金流,b6d7a8',
                ',b6d7a8',
                ',b6d7a8',
                ',b6d7a8',
                ',b6d7a8',
                ',b6d7a8',
                '(發票金額-折讓-入帳),b6d7a8',
                '（入帳-退款）,b6d7a8',
                '（入帳總額約當-退款總額約當）,b6d7a8',
                ',b6d7a8',
                ' (開立日期-完成日期）,b6d7a8',
                ',b6d7a8',
            ];
            break;
        case '退件':
            colorHeader = [
                ',FFFFFF',
                '資訊,d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                ',d9d9d9',
                '立帳,ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
                ',ffd966',
            ];
            break;
        default:
        }

        rows.push(colorHeader);
        rows.push(bodyHeaderCols);

        // 全部資料
        rows = rows.concat(bodyRows);
        return rows;
    }

    static AlphabetToNumber(col, isLetterSingle) {
        return isLetterSingle
            ? col.toLowerCase().charCodeAt(0) - 97
            : col
                .substring(1, 2)
                .toLowerCase()
                .charCodeAt(0)
                  - 97
                  + 26;
    }

    static createEmptyCols(amount) {
        const emptyCols = [];
        for (let i = 0; i < amount; i += 1) {
            emptyCols.push('');
        }
        return emptyCols;
    }

    static download(wb, fileName) {
        XLSX_STYLE.writeFile(wb, `${fileName}.xlsx`);
    }
}

export function downloadXlsx(wb, fileName) {
    XLSX_STYLE.writeFile(wb, `${fileName}.xlsx`);
}
